import { AUTHENTICATION_URL_PARAMS } from '../../types/authenticationContext.types';
import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import ForgeAuthenticationGate from './ForgeAuthenticationGate';
import ScrollToTop from '../../utils/ScrollToTop';

import { ExitToApp } from '@mui/icons-material';
import SetProjectSourceIdFromRoute from '../../hocs/ApplicationWrapper/features/ProjectSwitcher/SetProjectSourceIdFromRoute';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
export interface PagesProps {
	children?: React.ReactNode;
	authenticate?: boolean;
	isLandingPage?: boolean;
	readonly hasSharedWorkers: boolean;
}

const AuthenticationRouter = ({
	children,
	authenticate = false,
	isLandingPage = false,
	hasSharedWorkers,
}: PagesProps): JSX.Element => {
	const location = useLocation();
	const isProjectInjectionPage = location.pathname.includes('/projects/');

	const forgeAuthPaths: string[] = [AUTHENTICATION_URL_PARAMS.AUTODESK, '*'];

	const renderForgeRoute = (path: string): JSX.Element => (
		<Route key={path} exact={true} path={path}>
			<ScrollToTop elementId={'main'} />
			<ForgeAuthenticationGate
				authenticate={authenticate}
				hasSharedWorkers={hasSharedWorkers}
				isLandingPage={isLandingPage}>
				{children}
			</ForgeAuthenticationGate>
		</Route>
	);

	return isProjectInjectionPage ? (
		<Route
			exact
			path="/projects/:projectSourceId"
			component={SetProjectSourceIdFromRoute}
		/>
	) : (
		<Switch>
			<Route exact={true} path={'/login/automation'}>
				<StyledLink
					data-cy={'go-to-app'}
					to={'/'}
					style={{ display: 'flex', alignItems: 'center' }}>
					{'Go to app '}
					<ExitToApp />
				</StyledLink>
			</Route>
			{forgeAuthPaths.map(renderForgeRoute)}
		</Switch>
	);
};

const linksStyles = css`
	&&,
	&&:link,
	&&:visited {
		font-style: italic;
		font-weight: 400;
		font-size: 16px;
		line-height: 22px;
		color: #768d95;
	}
`;

const StyledLink = styled(Link)`
	${linksStyles}
`;

export default AuthenticationRouter;
